module.exports = __webpack_public_path__ + "assets/img/not_data_tips-5ac164a8.png";